import React from 'react';
import { Button } from '@ktag/styleguide/dist/react';
import { Sprite } from '@agissc/ktag-map';
import { useTranslation, Trans } from 'react-i18next';
import { useTracking } from '../../utils/tracking/TrackingContext';
import useResetUI from './useResetUi';

const Reset = () => {
  const { t } = useTranslation('agisviewer');
  const { Tracking } = useTracking();
  const resetUI = useResetUI();
  return (
    <div className="tooldialog__wrapper">
      <div className="tooldialog__wrapper-content">
        <p>
          <Sprite id="i-circle" additionalClassNames="reset__icon" />
          <Trans ns="agisviewer" i18nKey="reset_wrapper" />
        </p>
        <Button
          additionalClassNames="button__max-width"
          onClick={async () => {
            Tracking.UI.reset();
            await resetUI();
          }}
        >
          {t('reset_tool_label')}
        </Button>
      </div>
    </div>
  );
};

export default Reset;
